<template>
  <div class="modal_wrap" :class="{ on: show }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">알림 수신 동의</h1>
        </div>
        <div class="modal_con">
          <div class="modal_txt">
            <div>
              전송자: 퍼스<br />
              수신 동의 일시:
              {{ now }}<br />
              처리 내용: <span class="color bold">수신 동의 처리 완료</span
              ><br />
              <br />
              <span class="small grey"
                >※ [마이페이지 &gt; 알림 설정] 에서 언제든지 변경할 수
                있습니다.</span
              >
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <!--<button class="btn bo grey"></button>-->
            <button class="btn" @click="$emit('close')">확인</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { default as format } from 'date-fns/format';
export default {
  name: 'AppPushAgreeModal',

  props: {
    show: Boolean,
  },
  data() {
    return {
      now: format(new Date(), 'yyyy-MM-dd'),
    };
  },
};
</script>

<style scoped></style>
